import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEnvelopeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={11}
    fill="none"
    viewBox="0 0 14 11"
    {...props}
  >
    <path
      fill="#000"
      d="M0 3.19V8.4c0 1.16 1.045 2.1 2.333 2.1h9.334C12.955 10.5 14 9.56 14 8.4V2.1C14 .94 12.955 0 11.667 0H2.333C1.045 0 0 .94 0 2.1zm2.333-2.14h9.334c.644 0 1.166.47 1.166 1.05v.777L7 5.704 1.167 2.877V2.1c0-.58.522-1.05 1.166-1.05M1.167 4.07l5.557 2.692a.64.64 0 0 0 .553 0l5.556-2.693V8.4c0 .58-.522 1.05-1.166 1.05H2.333c-.644 0-1.166-.47-1.166-1.05z"
    />
  </svg>
);
export default SvgEnvelopeIcon;
